import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Miscellanious } from '@ops/global-config';
import { PricingPlanMapped, RecurringIntervalPrice } from '@ops/shared-types';
import { OpsInfoTooltipComponent } from '../ops-info-tooltip/ops-info-tooltip.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-subscription-card',
  standalone: true,
  imports: [CommonModule, OpsInfoTooltipComponent, TranslateModule],
  templateUrl: './ops-subscription-card.component.html',
  styleUrl: './ops-subscription-card.component.scss',
})
export class OpsSubscriptionCardComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() plan: PricingPlanMapped;
  @Input() isPreview?: boolean;
  @Input() isDisabled?: boolean;
  @Input() showMonthly?: boolean;

  @Input() isCreatingPlan?: boolean;

  @Input() selectedPlanId?: string;

  @Output() selectPlan?: EventEmitter<string> = new EventEmitter<string>();
  @Output() changePlan?: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelSubscription?: EventEmitter<string> =
    new EventEmitter<string>();

  @Input() selectedCurrency?: string = 'USD';

  priceForMonth?: RecurringIntervalPrice;
  priceForYear?: RecurringIntervalPrice;
  priceForMonthYearly?: string;

  iconInfoVisibleActiveProjects: boolean = false;
  iconInfoVisibleAddOns: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.updatePrices();
  }

  iconVisibleTimeout: any;

  setIconInfoVisibleActiveProjects(value: boolean) {
    clearTimeout(this.iconVisibleTimeout);

    if (value) {
      this.iconInfoVisibleActiveProjects = value;
    } else {
      this.iconVisibleTimeout = setTimeout(() => {
        this.iconInfoVisibleActiveProjects = value;
      }, 300);
    }
  }

  iconVisibleTimeoutAddOns: any;

  setIconInfoVisibleAddOns(value: boolean) {
    clearTimeout(this.iconVisibleTimeoutAddOns);

    if (value) {
      this.iconInfoVisibleAddOns = value;
    } else {
      this.iconVisibleTimeoutAddOns = setTimeout(() => {
        this.iconInfoVisibleAddOns = value;
      }, 301);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['selectedCurrency'] &&
      !changes['selectedCurrency'].firstChange
    ) {
      this.updatePrices();
    }
  }

  private updatePrices(): void {
    // console.log('selectedCurrency', this.selectedCurrency);
    // console.log(
    //   'this.plan.monthly[this.selectedCurrency]',
    //   this.plan.monthly[this.selectedCurrency]
    // );
    // console.log(
    //   'this.plan.yearly[this.selectedCurrency]',
    //   this.plan.yearly[this.selectedCurrency]
    // );

    this.priceForMonth = this.plan.monthly[this.selectedCurrency];
    this.priceForYear = this.plan.yearly[this.selectedCurrency];
    this.priceForMonthYearly = this.priceForYear
      ? (this.priceForYear.price / 12).toFixed(2)
      : undefined;
  }

  get isSelectedPlan() {
    if (
      !this.showMonthly &&
      this.plan.yearly[this.selectedCurrency]?.id === this.selectedPlanId
    ) {
      return true;
    }
    if (
      this.showMonthly &&
      this.plan.monthly[this.selectedCurrency]?.id === this.selectedPlanId
    ) {
      return true;
    }

    return false;
  }

  get currencyExchangeSymbol() {
    return Miscellanious.currencySymbolFromCode(
      'en-US',
      this.priceForYear?.currency || this.selectedCurrency || 'USD'
    );
  }

  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
  }

  onChangeCurrentPlan() {
    this.changePlan.emit();
  }

  onSelectPlan() {
    const planId = this.showMonthly
      ? this.priceForMonth.id
      : this.priceForYear.id;
    this.selectPlan.emit(planId);
  }

  onCancelSubscription() {
    // this.cancelSubscription.emit(this.plan.id);
  }
}
